module.exports = __webpack_public_path__ + "static/media/image6.933f1053.jpg";